import {RSAA} from "redux-api-middleware";
import {API_ENDPOINT, AUTH_HEADERS} from "../../util/constants";
import * as types from "../types";
import {handleUnauthorizedAccess} from "../../util/utility";

export function getPreDefinedTags(token, api_token) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/get-predefined-tags?api_token=${api_token}`,
            method: 'GET',
            headers: {
                ...AUTH_HEADERS,
                Authorization: `Bearer ${token}`
            },
            types: [types.PREDEFINED_TAGS_REQUEST, types.PREDEFINED_TAGS_RECEIVE,{
                type: types.PREDEFINED_TAGS_FAILURE,
                meta: (action, state, res) => {
                    return handleUnauthorizedAccess(action, state, res);
                }
            }]
        }
    }
}

export const resetPreDefinedTags = () => ({
    type: types.RESET_PREDEFINED_TAGS,
    payload: null
});